<template>
  <div>
    <!-- <el-button
      type="primary"
      icon="el-icon-plus"
      @click="setUserinfoDetailDialogVisible = true"
      >添加</el-button
    > -->
    <el-dialog
      :visible="userinfoDetailDialogVisible"
      title="修改个人信息"
      width="820px"
      @close="closeDialog"
    >
      <el-form :model="changeForm" ref="form" label-width="160px">
        <el-form-item label="注册时间：">
          {{ changeForm.createTime }}
        </el-form-item>
        <el-form-item label="注册来源：">
          <span>{{ changeForm.__registerFrom }}</span>
        </el-form-item>
        <el-form-item label="用户ID：">
          {{ changeForm.id }}
          <el-button
            size="mini"
            type="danger"
            @click="resetLoginPassword(changeForm.id)"
            >重置登录密码</el-button
          >
        </el-form-item>
        <el-form-item label="用户账号：">
          {{ changeForm.username }}
        </el-form-item>
        <el-form-item label="用户状态：">
          <span>{{
            changeForm.__userStatus && changeForm.__userStatus.text
          }}</span>
        </el-form-item>
        <el-form-item label="实名认证：">
          <span>
            {{ changeForm.__userStatus && changeForm.__idNoStatus.text }}</span
          >
        </el-form-item>
        <el-form-item label="谷歌认证：">
          <span>{{
            changeForm.__googleSecurityStatus &&
            changeForm.__googleSecurityStatus.text
          }}</span>
        </el-form-item>
        <el-form-item label="银行卡绑定状态：">
          <span>{{
            changeForm.__bankAuthStatus && changeForm.__bankAuthStatus.text
          }}</span>
        </el-form-item>
        <el-form-item label="是否迁移用户：">
          <span v-if="changeForm.oldOrNew === 'old'">是</span>
          <span v-else>否</span>
        </el-form-item>
        <el-form-item label="冻结状态：">
          <span v-if="changeForm.userStatus == 0">否</span>
          <span v-else-if="changeForm.userStatus == -1"
            >是（管理员ID：{{ changeForm.adminId }}，原因：{{
              changeForm.content
            }}）</span
          >
        </el-form-item>
        <el-form-item label="电话号码(区号必选)：">
          <el-input v-model="changeForm.tel">
            <el-select v-model="changeForm.telCountryCode" slot="append">
              <el-option
                v-for="(n, index) in countryCodeList"
                :key="index"
                :label="`+${n.code}`"
                :value="n.code"
              >
              </el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label="邮箱：">
          <el-input v-model="changeForm.email"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="handleSave">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'

export default {
  name: 'updatedialog',

  data() {
    return {
      changeForm: {
        id: '',
        tel: '',
        email: '',
        telCountryCode: '86',
      },
      rules: {
        telCountryCode: [
          { required: true, message: '区号必选', trigger: blur },
        ],
      },
    }
  },
  watch: {
    userinfoDetail(val, oldVal) {
      if (val !== oldVal) {
        this.changeForm = { ...val }
      }
    },
  },
  computed: {
    ...mapState('userOldSimulation', [
      'userinfoDetail',
      'userinfoDetailDialogVisible',
      'countryCodeList',
      'pagination',
      'queryType',
    ]),
    ...mapGetters('userOldSimulation', ['userList']),
  },
  methods: {
    ...mapMutations('userOldSimulation', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail',
    ]),
    ...mapActions('userOldSimulation', [
      'updatInfo',
      'list',
      'coutryCode',
      'resetPassword',
    ]),
    closeDialog() {
      this.setUserinfoDetailDialogVisible(false)
    },
    handleSave() {
      let updateInfo = {
        id: this.changeForm.id,
        tel: this.changeForm.tel,
        email: this.changeForm.email,
        telCountryCode: this.changeForm.telCountryCode,
      }
      this.updatInfo(updateInfo).then((res) => {
        if (res.code == 0) {
          this.setUserinfoDetailDialogVisible(false)
          this.$message.success('修改成功')
          this.list({
            queryType: this.queryType,
            queryValue: this.changeForm.id,
            // userStatus: '',
            // userType: '',
            // mark:null
          })
        }
      })
    },
    resetLoginPassword(id) {
      this.resetPassword({ userId: id }).then(() => {
        this.$message.success('重置成功！')
      })
    },
  },
  created() {
    this.coutryCode()
  },
}
</script>

<style lang="less" scoped>
::v-deep.el-select {
  .el-input__inner {
    width: 100px;
  }
}
</style>
